define('SC.SummitThemeExtension.Home', [
  'underscore',
  'SC.SummitThemeExtension.Common.Configuration',
  'SC.SummitThemeExtension.Common.LayoutHelper'
], function SummitThemeExtensionHome(_, Configuration, LayoutHelper) {
  'use strict';
  return {
    loadModule: function loadModule() {
      // for Carousel
      var carousel = Configuration.get('home.themeCarouselImages', []);
      var carouselObj;
      var isReady = false;
      // for Infoblocks
      var infoblock = Configuration.get('home.infoblock', []);
      // for Free text and images
      var freeTextImages = Configuration.get('home.freeTextImages', []);
      LayoutHelper.addToViewContextDefinition(
        'Home.View',
        'extraHome',
        'object',
        function (context) {
          carouselObj = context.carousel;
          isReady =
            _.has(context, 'isReady') && !_.isUndefined(context.isReady)
              ? context.isReady
              : true;
          if (!_.isEmpty(carouselObj)) {
            _.each(carouselObj, function (carousel) {
              if (!_.isEmpty(carousel.image)) {
                _.extend(carousel, {
                  isAbsoluteUrl: carousel.image.indexOf('core/media') !== -1
                });
              }
            });
          } else {
            carouselObj = carousel;
          }
          return {
            isReady: isReady,
            showCarousel: carouselObj && !!carouselObj.length,
            carousel: carouselObj,
            showInfoblocks: infoblock && !!infoblock.length,
            infoblock: infoblock,
            freeText: _(Configuration.get('home.freeText', '')).translate(),
            freeTextTitle: _(
              Configuration.get('home.freeTextTitle')
            ).translate(),
            showFreeTextImages: freeTextImages && !!freeTextImages.length,
            freeTextImages: freeTextImages
          };
        }
      );
    }
  };
});
